import type { BrandConfig } from '@indutrust/shared-model';

/**
 * Static brand configuration for the Indutrust platform.
 *
 * Provided at bootstrap via {@link provideIndutrustBrandConfig}.
 */
export const INDUTRUST_BRAND_CONFIG: BrandConfig = {
  brandId: 'indutrust',
  appName: 'Indutrust',
  logoUrl: '/assets/images/logo/indutrust.png',
  logoDarkUrl: '/assets/images/logo/indutrust-white.png',
  faviconUrl: '/favicon.png',
  supportedLangs: ['en', 'ar'],
  defaultLang: 'en',
  featureFlags: {},
  authStrategy: 'email-password',
};
